import { ChangeDetectorRef, Component, Input, signal } from '@angular/core';
import { CommonModule, NgFor, NgOptimizedImage } from '@angular/common';
import { ProductService } from 'src/app/services/product.service';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { TranslateModule } from '@ngx-translate/core';
import { MediaMatcher } from '@angular/cdk/layout';
import { CommonConfig } from 'src/app/shared/common-config/common-config';
import { trigger, transition, style, animate, query, stagger, group } from '@angular/animations';
import { SharedModule } from 'src/app/shared/shared.module';
import { Product } from '@mare-common/ngx-delfi-components/lib/products-list/product.interface';
import { EventInteractionService } from '@mare-common/ngx-mare-common';

 export interface ProductPromo {
  title: string;
  description: string;
   image: string;
   sku?: string;
   id?: number
 }
export interface SinglePromoProduct extends Product{
   promo_title?: string;
   promo_box?: string;
  promo_image_url?: string;
  short_description?: string;
   
}
 /** 
  * Promo product component
  * Mostra il prodotto con un layout a banner con immagine di sfondo e il titolo, descrizione e bottone incolonnati a bandiera sinistra
  * Il bottone fa una  router.navigate alla pagina product/[skuprodotto]
  * 
  * @parms optional  productIds: number | number[]
  * @parms optional  product: SinglePromoProduct
  * @selector app-promo-product
  * @usage <app-promo-product [productIds]="[1,2,3]"></app-promo-product> or <app-promo-product [product]="product"></app-promo-product>
  * @events 
  */
@Component({
  selector: 'app-promo-product',
  standalone: true,
  imports: [CommonModule,
    MatCardModule,
    MatButtonModule,
    TranslateModule,
    NgOptimizedImage,
    SharedModule],
  templateUrl: './promo-product.component.html',
  styleUrls: ['./promo-product.component.scss'],
  animations: [
    trigger('listAnimation', [
      transition('* => *', [
        query('.promo-card', [
          style({ opacity: 0, transform: 'translateY(100%)' }),
          stagger(1000, [
            group([
              animate('700ms 300ms ease-out', style({ opacity: 1, transform: 'translateY(0)' })),
              query('.promo-image,.promo-title, .promo-description, .promo-button', [
                style({ opacity: 0, transform: 'translateY(100%)' }),
                stagger(1000, [
                  animate('700ms 300ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
                ])
              ])
            ])
          ])
        ], { optional: true })
      ])
    ])
  ]
})
export class PromoProductComponent {

  @Input() productIds?: number | number[];// effettuiamo un fetch dei prodotti by id
  @Input() product?: SinglePromoProduct; // mostriamo direttamente il prodotto singolo 
  @Input() preventRouting = false;
  @Input() contentAlign: 'left' | 'right' | 'center' = 'left';
  
  _contentAlign: string;

  products: Array<any> = [];
  singleProduct: any;
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  productBgImage$ = signal<string>('');
  
  isInVew$ = signal(false);

  constructor(private productService: ProductService,
    private router: Router,
    private media: MediaMatcher,
    private commonConfig: CommonConfig,
    changeDetectorRef: ChangeDetectorRef,
    private eventInteractionService: EventInteractionService
  ) { 
    // this.isMobile = this.platform.ANDROID || this.platform.IOS;
    this.mobileQuery = media.matchMedia('(min-width: ' + commonConfig.getMobileBreakpoint() + 'px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addEventListener('resize', this._mobileQueryListener);
    this._contentAlign = this.mapAlign();
  }

  ngOnInit(): void {
   if((Array.isArray(this.productIds) && this.productIds.length > 0) || this.productIds) {
    console.log(this.productIds);
   
    this.productService.getProductById(this.productIds).then((products: any) => {
        console.log(products);
        
        this.products = products.map((prod:any) => {
          return {
            title: prod.promo_title && prod.promo_title.trim() !== '' ? prod.promo_title : prod.name,
            description: prod.promo_box && prod.promo_box.trim() !== '' ? prod.promo_box : prod.description,
            image: prod.promo_image_url && prod.promo_image_url.trim() !== '' ?  prod.promo_image_url : prod.image,
            sku: prod.sku,
            id: prod.id
          }
        })
      return this.products
    }) 
   }
  //  else if (this.product) {
  //    let prod = this.product;
  //     this.singleProduct = {
  //         title: prod.promo_title && prod.promo_title.trim() !== '' ? prod.promo_title : prod.name,
  //         description: prod.promo_box && prod.promo_box.trim() !== '' ? prod.promo_box : prod.short_description,
  //         image: prod.promo_image_url && prod.promo_image_url.trim() !== '' ?  prod.promo_image_url : prod.image_url,
  //         sku: prod.sku,
  //         id: prod.id
  //       }
  //  } else {
  //    return;
  //   }
   
  }

  mapAlign() {
    switch (this.contentAlign) {
      case 'left':
        return 'align-items-start';
      case 'right':
        return 'align-items-end';
      case 'center':
        return 'align-items-center';
      default:
        return 'align-items-start';
    }
  }

  goToProduct(product: any) {
    if (this.preventRouting) {
      this.eventInteractionService.publishData({ event: 'goToProduct', data: product });
      return;
    }
    this.router.navigate([environment.routingBasePath + '/product/' + product.sku])
    
  }

  onInViewChange(event:any) {
    if(event)
      this.isInVew$.set(true);
  }

}
